export default __webpack_public_path__ + "static/media/5 - Killer.7bff7f71.mp3";